import { Stack } from '@mui/system'
import { Countdown } from 'components/Countdown'
import { useTranslation } from 'react-i18next'
import { ITender } from 'types/tender'

type Props = { tender: ITender }

export const TenderCountdown = ({ tender }: Props) => {
  const { t } = useTranslation()

  return (
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      alignItems="center"
      justifyContent={{ xs: 'center', lg: 'space-around' }}
      spacing={3}
      sx={{ backgroundColor: '#999', padding: 2 }}
    >
      <Countdown
        title={t('required-docs')}
        expiryTimestamp={new Date((tender.docSubmissionDeadline as number) * 1000)}
      />
      <Countdown
        title={t('envelope-opening')}
        expiryTimestamp={new Date((tender.envelopeOpeningTime as number) * 1000)}
      />
    </Stack>
  )
}
